module.exports = __webpack_public_path__ + "static/media/SM.79e6ab05.png";